import { Heading } from '@lmig/lmds-react-typography';
import { ISliderContext, LinksPanelType } from '../Models/Panels';
import { AccordionLinks } from './AccordionLinks';
import './FavoritesPanel.scss';
import { SliderContext } from '../SliderContext';
import { useEffect, useContext, useState } from 'react';
import { SearchInput } from '@lmig/lmds-react-alphanumeric-input';

interface ILinksPanel {
  panel: LinksPanelType;
}
export function LinksPanel({ panel }: ILinksPanel) {
  const sliderContext = useContext<ISliderContext>(SliderContext);
  const [localPanel, setLocalPanel] = useState<LinksPanelType>(panel);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (localPanel && !sliderContext.panels) sliderContext.addPanel(localPanel);
    if (!localPanel) setLocalPanel(panel);
  }, [sliderContext, sliderContext.panels, localPanel]);

  if (localPanel)
    return (
      <>
        <Heading type="h4">{localPanel.title}</Heading>
        <div data-theme="evolved">
          <SearchInput
            id={`${localPanel.title?.toLowerCase().replaceAll(' ', '-')}-search`}
            labelVisual={`Search ${localPanel.title?.toLowerCase()}`}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            aria-live="polite"
            onClearClicked={() => setSearchValue('')}
          />
        </div>
        <AccordionLinks
          sections={localPanel.sections}
          filterTerm={searchValue}
          usesFavorites={false}
          id={localPanel.title}
        />
      </>
    );
  else return <></>;
}

export default LinksPanel;
